import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes'
import type { JSX } from 'react/jsx-runtime'

export const ThemeProvider = ({
  children,
  ...properties
}: Readonly<ThemeProviderProps>): JSX.Element => {
  return <NextThemesProvider {...properties}>{children}</NextThemesProvider>
}
